//********** TST defaults
window.TST = window.TST || {
	onReady: function () {
		const tagVal = "#caa-widget-travel",
			focusTab = document.getElementById("tst_tab_focus_input").value,
			productsList = document.getElementById("tst_products_text").innerText;
		TST.init(TST.config);
		TST.SearchWidget.create({
			// The tag / node that the widget should be attached to
			tag: tagVal,

			// Products: ALL defaults to: flight, car, hotel, activity. To specify your own products, use an array. E.g.: ['hotel', 'flight', 'car']
			products: productsList.split(","), //['hotel', 'car', 'flight', 'prepackaged', 'cruise', 'activity'],

			// this is the "selected" or "active" tab when the widget initializes.
			focus: focusTab, // 'Stays',
			tabDirection: 'horizontal',
			extras: {
				autoComplete: true,
				datePicker: true
			},
		});
	}
};

(function (window, document) {
	const hostVal = document.getElementById("tst_host_url_input").value;
	window.TST.config = {
		host: hostVal, //Caasco.client.infra.tstllc.net example amatravel.tstllc.net or etravel.az.aaa.com CAASCO caasco.tstllc.net
		selfHostUrlTstApi: '/~/media/development/travel/js/tstapimin' // example https://urdomain.com/vendor/tst-search-widget/js/tst-api.min.js
	}

	var w = document.createElement('script');
	w.type = 'text/javascript';
	w.async = true;


	if (window.TST.config.selfHostUrlTstApi) {

		w.src = window.TST.config.selfHostUrlTstApi;

	} else {

		w.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + window.TST.config.host + '/web-services/assets/javascript/tst-api.min.js';

	}


	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(w, s);
})(window, document);

//********** TST Custom / UI Updates
document.addEventListener('readystatechange', function(ev) {// applying loading modal
	const blockUI = document.querySelector(".block-ui");
	if (document.readyState ===  "interactive") {
		blockUI.style.display = "block";
	}
	if (document.readyState ===  "complete") {
		blockUI.style.display = "none";
	}
});
const TSTWidget = {
  version: "1.0",
  author: "CAA Digital",
  project: "TST Travel Widget",
  Date: "Dec 2022",

  //initialization

  init: function () {
    //This empty room value from localstorage to avoid stuck room selection
    const hotelsLocalStorageData = JSON.parse(window.localStorage.getItem('common-search.hotel'));
    if (hotelsLocalStorageData) {
        hotelsLocalStorageData.rooms = '';
        window.localStorage.setItem('common-search.hotel', JSON.stringify(hotelsLocalStorageData));
    }
    const context = this;
    //Global variables
    context.config = {
      travelWidget: document.getElementById("caa-widget-travel"),
      tabsTitleLabel: ["Stays", "Cars", "flights", "Packages & Tours", "Cruises", "Things to do"],
      hotelLabels: ["Destination", "Check-in date <span class='input__text-placeholder'>(Optional)</span>", "Check-out date <span class='input__text-placeholder'>(Optional)</span>", "Room Occupancy"],
      vacayRentalLabels: [
        "Destination",
        'Check-in date <span class="input__text-placeholder">(Optional)</span>',
        'Check-out date <span class="input__text-placeholder">(Optional)</span>',
        "Occupancy",
      ],
      carLabels: ["Pickup destination", "Drop-off destination <span class='input__text-placeholder'>(Optional)</span>", "Pickup date", "Pickup time", "Drop-off date", "Drop-off time"],
      flightLabels: [
        "Departing from",
        "Departure date",
        "Destination",
        "Return date",
        "Adults <span class='input__text-placeholder'>(Optional)</span>",
        "Seniors <span class='input__text-placeholder'>(Optional)</span>",
        "Children <span class='input__text-placeholder'>(Optional)</span>",
      ],
      vacationLabels: ["Departing from", "Destination/Resort", "Departure date", "Duration (nights)", "Room Occupancy", "Adults", "Children <span class='input__text-placeholder'>(Optional)</span>"],
      guidedToursLabels: ["Destination", "Month"],
      cruiseLabels: ["Destination", "Duration (nights)", "Month of departure", "Cruise line", "Travelers"],
      activityLabels: ["Destination", "Month"],
      dateRegex: `^(0[1-9]|1[0-2])[\-](0[1-9]|[12][0-9]|3[01])[\-](20)[0-9]{2}$`,
      invalidDateErrorMessage: "Please enter a valid date.",
      dateFormat: "mm-dd-yyyy",
      tabsId: ["tst_hotel_tab", "tst_car_tab", "tst_flight_tab", "tst_vacation_tab", "tst_cruises_tab", "tst_thingstodo_tab", "tst_vacation_hidden_tab", "tst_tours_hidden_tab"],
      globalRequiredCopy: "All fields are required unless marked optional.",
      childAgeLabels: ["First child's age", "Second child's age", "Third child's age", "Fourth child's age"],
      maxTravelersExceeded: "Please enter a maximum of 6 travellers.",
      advanceSearchBurb: 'Don\'t see what you\'re looking for? Try our <a href="//www.caascotravel.com/hotel" class="advanced-search-link link">Advanced Search</a>',
      occupancyLabels: ["Room", "Adults", "Children"],
      currTab: "tst_hotel_tab",
      adultChildMinMax: {
        max: { adults: 14, child: 6 },
        min: { adults: 2, child: 0 },
      },
      _checker: (arr) => arr.every((a) => a === true), //Check if the validationFlagArray has all the true values
      _setAttribute: (arr) => {
        /**
         * arr data model
         * @param selector = value.selector
         * @param Attribute Type = value.attrType
         * @param Attribute Value = value.attrValue
         */
        //selector, attrType, attrValue
        arr.forEach((value) => {
          if (value.selector) value.selector.setAttribute(value.attrType, value.attrValue);
        });
      },
      _addClass: (arr) => {
        /**
         * arr data model
         * @param selector = value.selector
         * @param Class Name / Names(array) = value.className
         */
        //selector, attrType, attrValue
        arr.forEach((value) => {
          if (typeof value.className == "string") {
            value.selector.classList.add(value.className);
          }
          if (typeof value.className == "object") {
            for (let className of value.className) {
              value.selector.classList.add(className);
            }
          }
        });
      },
      _tabsTitleLabel: () => {
        const tabsLinkElement = document.querySelectorAll("#tst-tabs ul li a span");
        let tabsTitleLabelArr = [];

        for (let element of tabsLinkElement) {
          switch (true) {
            case element.innerText == "Hotel":
              tabsTitleLabelArr.push("Stays");
              break;
            case element.innerText == "Flight":
              tabsTitleLabelArr.push("Flights");
              break;
            case element.innerText == "Car":
              tabsTitleLabelArr.push("Cars");
              break;
            case element.innerText == "Vacations":
              tabsTitleLabelArr.push("Packages & Tours");
              break;
            case element.innerText == "Cruise":
              tabsTitleLabelArr.push("Cruises");
              break;
            case element.innerText == "Activity":
              tabsTitleLabelArr.push("Things to do");
              break;
          }
        }
        return tabsTitleLabelArr;
      },
      _toggleTabFeatureButtons: function (firstToogleBtn, otherToggleBtn) {
        // Only used in below tabs
        // Stays - Hotels and Vacation Rentals
        // Package and tours - Vacation Packages and Guided Tours
        const context = this;
        firstToogleBtn.classList.add("btnActive");
        otherToggleBtn.classList.remove("btnActive");
        context._setAttribute([
          {
            selector: firstToogleBtn,
            attrType: "aria-pressed",
            attrValue: "true",
          },
          {
            selector: otherToggleBtn,
            attrType: "aria-pressed",
            attrValue: "false",
          },
        ]);
      },
    };

    //Call DOM invoking functions here
    context.widgetGlobals();
    context.widgetNavigation();
    context.widgetSubNavigation();
    context.widgetHotel();
    context.widgetVacationRentals();
    context.widgetCar();
    context.widgetFlight();
    context.widgetVacation();
    context.widgetGuidedTours();
    context.widgetCruise();
    context.widgetActivity();
    context.eventHandlers();
    context.formValidation();
    context.selectActiveTab();
    context.handleOccupancyEvents();
  },

  widgetNavigation: function () {
    const context = this,
      tabsTitleLabel = context.config._tabsTitleLabel(),
      tabList = document.querySelector("#tst-tabs ul"),
      tabListElementLinks = document.querySelectorAll("#caa-widget-travel .search nav ul li a"),
      fieldsets = document.querySelectorAll(".forms fieldset");
    const idMapper = {
      "#hotel": ["tst_hotel_tab", "hotel"],
      "#car": ["tst_car_tab", "car"],
      "#flight": ["tst_flight_tab", "flight"],
      "#prepackaged": ["tst_vacation_tab", "prepackaged"],
      "#cruise": ["tst_cruises_tab", "cruise"],
      "#activity": ["tst_thingstodo_tab", "activity"],
      "#vacation": ["tst_vacation_hidden_tab", "vacation_hidden"],
      "#tour": ["tst_tours_hidden_tab", "tours_hidden"],
    };

    //Change Tabs labels & convert to Uppercase & // Make it tablist AODA
    for (const [index, tabListElement] of tabListElementLinks.entries()) {
      const value = tabListElement.children[1];
      value.innerHTML = tabsTitleLabel[index];
      value.style.textTransform = "uppercase";

      context.config._setAttribute([
        {
          selector: tabListElement.parentNode,
          attrType: "role",
          attrValue: "presentation",
        },
        {
          selector: tabListElement,
          attrType: "role",
          attrValue: "tab",
        },
        {
          selector: tabListElement,
          attrType: "aria-pressed",
          attrValue: "false",
        },
        {
          selector: tabListElement,
          attrType: "aria-controls",
          attrValue: fieldsets[index].getAttribute("id"),
        },
        {
          selector: tabListElement,
          attrType: "id",
          attrValue: context.config.tabsId[index],
        },
      ]);
    }

    for (const [i, fieldset] of fieldsets.entries()) {
      context.config._setAttribute([
        {
          selector: fieldset,
          attrType: "role",
          attrValue: "tabpanel",
        },
      ]);
    }

    context.config._setAttribute([
      {
        selector: tabList,
        attrType: "role",
        attrValue: "tablist",
      },
      {
        selector: tabList,
        attrType: "aria-label",
        attrValue: "Travel search widget",
      },
      {
        selector: fieldsets[0],
        attrType: "aria-labelledby",
        attrValue: context.config.tabsId[2],
      },
      {
        selector: fieldsets[1],
        attrType: "aria-labelledby",
        attrValue: context.config.tabsId[0],
      },
      {
        selector: fieldsets[2],
        attrType: "aria-labelledby",
        attrValue: context.config.tabsId[1],
      },
      {
        selector: fieldsets[3],
        attrType: "aria-labelledby",
        attrValue: context.config.tabsId[5],
      },
      {
        selector: fieldsets[4],
        attrType: "aria-labelledby",
        attrValue: context.config.tabsId[3],
      },
      {
        selector: fieldsets[5],
        attrType: "aria-labelledby",
        attrValue: context.config.tabsId[4],
      },
    ]);

    // Fix for existing PROD issue where tab href did not align with the tab's id and aria-control attributes
    tabListElementLinks.forEach((element) => {
      const setIdsAndAttributes = (target) => {
        if (element.getAttribute("href") === target) {
          element.id = idMapper[target][0];
          element.setAttribute("aria-controls", idMapper[target][1]);
        }
      };

      setIdsAndAttributes("#hotel");
      setIdsAndAttributes("#car");
      setIdsAndAttributes("#flight");
      setIdsAndAttributes("#prepackaged");
      setIdsAndAttributes("#cruise");
      setIdsAndAttributes("#activity");
      setIdsAndAttributes("#vacation");
      setIdsAndAttributes("#tour");
    });
  },

  widgetSubNavigation: function () {
    const context = this;
    const pkgField = document.getElementById("prepackaged");
    const divEl = document.createElement("div");
    const tstToggleData = {
        hotel: {
          toggleLabel: "Pick your stay ",
          togglelabelledby: "tst_hotel_tab",
          btnData: [
            {
              btnLabel: "Hotels",
              btnId: "hotels",
            },
            {
              btnLabel: '<span class="mobileLineBreak">Vacation</span> Rentals',
              btnId: "vacationRentals",
            },
          ],
        },
        packages: {
          toggleLabel: "Pick your package",
          togglelabelledby: "tst_vacation_tab",
          btnData: [
            {
              btnLabel: '<span class="mobileLineBreak">Vacation</span> Packages',
              btnId: "vacationPackages",
            },
            {
              btnLabel: '<span class="mobileLineBreak">Guided</span> Tours',
              btnId: "guidedTours",
            },
          ],
        },
      },
      toggleDataHotel = tstToggleData.hotel,
      toggleDataPackages = tstToggleData.packages;

    context.config._addClass([
      {
        selector: divEl,
        className: "formToggle",
      },
    ]);

    context.config._setAttribute([
      {
        selector: pkgField,
        attrType: "aria-labelledby",
        attrValue: "tst_vacation_tab",
      },
    ]);

    const hotelPackageToggle = (toggleTarget) => {
      const renderToggleButtons = (targetLocation) => {
        return `
						<p class='paragraph tst-copy__mandatory' aria-labelledby='${targetLocation.togglelabelledby}'>${targetLocation.toggleLabel}</p>
						<div class='toggleWrapper col-sm-12' role="tablist">
							<div class='buttonWrapper col-sm-12 col-md-6'>
								<button type='button' id='${targetLocation.btnData[0].btnId}' class='toggleBtn btnActive' aria-pressed='true'>${targetLocation.btnData[0].btnLabel}</button>
								<button type='button' id='${targetLocation.btnData[1].btnId}' class='toggleBtn' aria-pressed='false'>${targetLocation.btnData[1].btnLabel}</button>
							</div>
						</div>
					`;
      };

      return renderToggleButtons(toggleTarget === "hotel" ? toggleDataHotel : toggleDataPackages);
    };

    const tabButtonHandler = () => {
      // Toggle Button click event
      document.addEventListener(
        "click",
        (event) => {
          const elem = event.target;
          const elemType = elem.nodeName.toLowerCase();
          if (elemType === "button" && elem.classList.contains("toggleBtn")) {
            const hotelForm = document.getElementById("hotel-form"),
              vacationRentalsForm = document.getElementById("vacation-rentals-form"),
              vacationPackagesForm = document.getElementById("prepackaged"),
              guidedToursForm = document.querySelector("section.forms > fieldset.tour-section"),
              eventId = event.target.id,
              toggleBtnParent = elem.closest("div.formToggle");

            const butonHandler = (formTargetA, targetAdisplay, formTargetB, targetBdisplay, isTours) => {
              if (!isTours) {
                formTargetA.style.display = targetAdisplay;
                formTargetB.style.display = targetBdisplay;
              } else {
                if (eventId == "vacationPackages") {
                  formTargetA.classList.add("active");
                  formTargetB.classList.remove("active");
                }

                if (eventId == "guidedTours") {
                  formTargetA.classList.remove("active");
                  formTargetB.classList.add("active");
                }
              }
            };

            const otherToggleBtn = elem.nextElementSibling || elem.previousElementSibling;

            context.config._toggleTabFeatureButtons(elem, otherToggleBtn);

            // TOGGLE HOTELS/VACATION RENTALS | VACATON PACKAGES/GUIDED TOURS
            let newDOMParentId = null;

            switch (eventId) {
              case "hotels":
                butonHandler(hotelForm, "block", vacationRentalsForm, "none", false);
                break;
              case "vacationRentals":
                butonHandler(hotelForm, "none", vacationRentalsForm, "block", false);
                break;
              case "vacationPackages":
                newDOMParentId = "#prepackaged";
                butonHandler(vacationPackagesForm, "block", guidedToursForm, "none", true);
                break;
              case "guidedTours":
                newDOMParentId = "#tours";
                butonHandler(vacationPackagesForm, "none", guidedToursForm, "block", true);
                break;
              default:
                console.log(`Button ID not available.`);
            }

            if (newDOMParentId) {
              const newDOMParent = document.querySelector(newDOMParentId);

              // Shift toggle button DOM Parent
              newDOMParent.prepend(toggleBtnParent);
            }
          }
        },
        false
      );
    };

    const addToggleButton = (fieldsetId) => {
      const staysAndPackages = document.getElementById(fieldsetId);
      const divEl = document.createElement("div");
      context.config._addClass([
        {
          selector: divEl,
          className: "formToggle",
        },
      ]);

      divEl.innerHTML = hotelPackageToggle(fieldsetId);
      staysAndPackages.insertBefore(divEl, staysAndPackages.firstChild);
    };

    // Add Toggle button in STAYS/HOTEL Form
    addToggleButton("hotel");

    // Add Toggle button in PACKAGE Form
    addToggleButton("prepackaged");

    tabButtonHandler();

    const hotelSection = document.querySelector("#hotel-form");
    const vacationRentalsSection = document.querySelector("#vacation-rentals-form");
    context.config._setAttribute([
      {
        selector: hotelSection,
        attrType: "aria-labelledby",
        attrValue: "hotels",
      },
      {
        selector: vacationRentalsSection,
        attrType: "aria-labelledby",
        attrValue: "vacationRentals",
      },
      {
        selector: hotelSection,
        attrType: "role",
        attrValue: "tabpanel",
      },
      {
        selector: vacationRentalsSection,
        attrType: "role",
        attrValue: "tabpanel",
      },
    ]);

    const vacationPackagesSection = document.querySelector("#prepackaged");
    const guidedToursSection = document.querySelector(".tour-section");
    context.config._setAttribute([
      {
        selector: vacationPackagesSection,
        attrType: "aria-labelledby",
        attrValue: "tst_vacation_tab",
      },
      {
        selector: guidedToursSection,
        attrType: "aria-labelledby",
        attrValue: "tst_vacation_tab",
      },
    ]);
  },

  widgetGlobals: function () {
    const context = this,
      advanceSearchContainers = document.querySelectorAll(".tst-search-widget form .tst-advanced-search"),
      flightFormAdvanceSearch = document.querySelector(".tst-search-widget #flight-form .tst-advanced-search"),
      flightFormBtncontainer = document.querySelector(".tst-search-widget #flight-form .search-btn");

    //Add Advance search link
    flightFormBtncontainer.innerHTML += `<div class='advance-search'>${flightFormAdvanceSearch.innerHTML}</div>`;
    flightFormBtncontainer.childNodes[3].children[0].classList.add("link");
    for (let advanceSearchContainer of advanceSearchContainers) {
      const btnContainer = advanceSearchContainer.previousElementSibling;
      btnContainer.innerHTML += `<div class='advance-search'> ${advanceSearchContainer.innerHTML} </div>`;
      advanceSearchContainer.children[0].classList.add("link");
      btnContainer.lastChild.childNodes[1].classList.add("link");
    }

    //Create fields container and insert all the fields in: tst-widget-fields__container
    const TravelTypeForms = document.querySelectorAll("fieldset form");
    for (let TravelTypeForm of TravelTypeForms) {
      let fieldsContainer = document.createElement("DIV");
      fieldsContainer.classList.add("tst-widget-fields__container");
      TravelTypeForm.prepend(fieldsContainer);
    }

    //Add col-sm-12 to all input fields
    const allInputs = document.querySelectorAll("#caa-widget-travel input");
    for (let input of allInputs) {
      input.classList.add("col-sm-12");
    }

    //Current location button
    setTimeout(function () {
      const currentLocationButtons = document.querySelectorAll(".location-icon a");
      for (let currentLocationButton of currentLocationButtons) {
        context.config._setAttribute([
          {
            selector: currentLocationButton,
            attrType: "role",
            attrValue: "button",
          },
          {
            selector: currentLocationButton,
            attrType: "aria-label",
            attrValue: "Get current location",
          },
        ]);
      }
    }, 50);

    //Insert Validation markup
    const validationHTML = `<section class="page-error-block page-error-block__details d-none">
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12  col-lg-12 col-md-12">
                    <div class="form__error form__error-summary notification notification__top">
                        <div class="alert alert-danger alert-dismissible">
                            <div class="validation-summary-errors">
                                <div class="validation__summary-copy" id="page_error_block" tabindex="-1" aria-atomic="true"
                                    role="text" aria-live="assertive">
                                    There are <span id="page_error_count">2</span> error(s) found in the information you
                                    submitted.
                                </div>
                                <ul id="page_error_list" class="page-error__list">
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        	</div>
    		</section>`,
      formsSectioncontainer = document.querySelector("#caa-widget-travel .forms");

    const insertParagraph = `<p class="paragraph tst-copy__mandatory">${context.config.globalRequiredCopy}</p>`;
    formsSectioncontainer.innerHTML = insertParagraph + validationHTML + formsSectioncontainer.innerHTML;

    //Insert Parsley date data attributes
    //data-parsley-pattern data-parsley-pattern-message
    const allDatePickers = document.querySelectorAll("input[data-tst-datepicker]");

    for (let datepicker of allDatePickers) {
      context.config._setAttribute([
        {
          selector: datepicker,
          attrType: "data-parsley-pattern",
          attrValue: context.config.dateRegex,
        },
        {
          selector: datepicker,
          attrType: "data-parsley-pattern-message",
          attrValue: context.config.invalidDateErrorMessage,
        },
        {
          selector: datepicker,
          attrType: "data-format",
          attrValue: context.config.dateFormat,
        },
      ]);
    }

    const requiredHolder = document.querySelector(".forms > .tst-copy__mandatory");

    context.config._addClass([
      {
        selector: requiredHolder,
        className: ["justifyRight", "mobileJustifyLeft"],
      },
    ]);

    // For Hotels and Vacation rental occupany selection update announcement (accessibility)
    const roomsLabel = document.querySelector("#hotel-form .roomsLabel");
    const adultsLabel = document.querySelectorAll(".adultsLabel");
    const childrenLabel = document.querySelectorAll(".childrenLabel");

    context.config._setAttribute([
      {
        selector: roomsLabel,
        attrType: "aria-live",
        attrValue: "polite",
      },
      {
        selector: adultsLabel[0],
        attrType: "aria-live",
        attrValue: "polite",
      },
      {
        selector: adultsLabel[1],
        attrType: "aria-live",
        attrValue: "polite",
      },
      {
        selector: childrenLabel[0],
        attrType: "aria-live",
        attrValue: "polite",
      },
      {
        selector: childrenLabel[1],
        attrType: "aria-live",
        attrValue: "polite",
      },
    ]);
  },

  handleOccupancyEvents: function () {
    const context = this;
    const childAgeContainer = document.querySelector("#hotel-form .childAgesContainer");
    const vacationPlusParentButton = document.querySelector("#vacation-rentals-form .selector-adults .buttonPlus");
    const vacationMinusParentButton = document.querySelector("#vacation-rentals-form .selector-adults .buttonMinus");
    const vacationMinusButtonPlusChildren = document.querySelector("#vacation-rentals-form .selector-children .buttonPlus");
    const vacationMinusButtonMinusChildren = document.querySelector("#vacation-rentals-form .selector-children .buttonMinus");
    const adultLabel = document.querySelector("#vacation-rentals-form .adultsLabel");
    const childLabel = document.querySelector("#vacation-rentals-form .childrenLabel");
    const roomsSummaryContainer = document.querySelector("#vacation-rentals-form .roomsSummary");
    const vacationRentalsAdultsCount = document.getElementById("vacationRentalsAdultsCount");
    const vacationRentalsChildrenCount = document.getElementById("vacationRentalsChildrenCount");
    const vacationPlusMinusHolders = document.querySelectorAll("#vacation-rentals-form .plusMinusHolder");
    const childAgesRequiredLabel = document.querySelector("#vacation-rentals-form .childAgesRequiredLabel");
    const vacayRentalChildAgesContainer = document.querySelector("#vacation-rentals-form .childAgesContainer");
    const adultPlusMinusHolder = vacationPlusMinusHolders[0];
    const childPlusMinusHolder = vacationPlusMinusHolders[1];
    const adultPlusButton = adultPlusMinusHolder.querySelector(".buttonPlus");
    const adultMinusButton = adultPlusMinusHolder.querySelector(".buttonMinus");
    const childPlusButton = childPlusMinusHolder.querySelector(".buttonPlus");
    const childMinusButton = childPlusMinusHolder.querySelector(".buttonMinus");

    // Options for the observer (which mutations to observe)
    const mutationObserverConfig = {
      attributes: true,
      childList: true,
      subtree: true,
    };

    const adultChildMinMax = context.config.adultChildMinMax;

    let adultCount = adultChildMinMax.min.adults;
    let childCount = adultChildMinMax.min.child;

    adultLabel.innerHTML = `${adultCount} Adults`;
    childLabel.innerHTML = `${childCount} Children`;

    let prevChildCount = 0;

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          const childrenCount = childAgeContainer.childNodes?.length;
          const childAgeContainerLastChild = childAgeContainer.lastChild;

          if (prevChildCount != childrenCount) {
            prevChildCount = childrenCount;

            if (childAgeContainerLastChild) {
              const childAgeDropDown = childAgeContainerLastChild.querySelector("select");

              context.config._setAttribute([
                {
                  selector: childAgeDropDown,
                  attrType: "aria-required",
                  attrValue: true,
                },
                {
                  selector: childAgeDropDown,
                  attrType: "aria-label",
                  attrValue: `Age of child ${childrenCount}`,
                },
              ]);

              // if (mutation.addedNodes.length > 0) {
              // 	contentDivWrapper(childAgeContainerLastChild, childrenCount);
              // }
            }
          }
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(childAgeContainer, mutationObserverConfig);

    context.config._addClass([
      {
        selector: adultMinusButton,
        className: "disabled",
      },
    ]);

    const handleVacayRentalPlusMinus = (button, type) => {
      button.addEventListener("click", (event, index) => {
        const targetButton = event.target;
        const buttonClass = targetButton.classList;
        const plusMinusLabelHolder = event.target.parentElement.childNodes[3];
        const plusMinusLabelHolderClasses = event.target.parentNode.querySelector("span").classList;

        const updateRoomSummary = (adult, child) => {
          const adultText = `${adult} ${adult > 1 ? "Adults" : "Adult"}`;
          const childText = child > 0 ? `${child} ${child > 1 ? "Children" : "Child"}` : "";
          roomsSummaryContainer.innerHTML = `${adultText}${childText ? `, ${childText}` : ""}`;
        };

        const grammarNumHandler = (changeTypeCount, type) => {
          let placeholderText = "";
          if (type === "adult") {
            placeholderText = changeTypeCount === 1 ? `${changeTypeCount} Adult` : `${changeTypeCount} Adults`;
          }

          if (type === "children") {
            placeholderText = changeTypeCount === 1 ? `${changeTypeCount} Child` : `${changeTypeCount} Children`;
          }

          plusMinusLabelHolder.innerHTML = placeholderText;
        };

        // Function to increment count
        const handleIncrement = (numberLabelClassList) => {
          const {
            max: { adults: adultMaxNum, child: childMaxNum },
          } = adultChildMinMax;

          // Function to increment adult or child
          const adultChildIncrementHandler = (typeCount, typeMax) => {
            if (typeCount === adultCount) {
              grammarNumHandler(typeCount, "adult");
            }
            if (typeCount === childCount) {
              grammarNumHandler(typeCount, "children");
            }

            if (typeCount == typeMax) {
              context.config._addClass([
                {
                  selector: targetButton,
                  className: "disabled",
                },
              ]);
            }
          };

          if (numberLabelClassList == "adultsLabel") {
            adultCount += 1;
            adultChildIncrementHandler(adultCount, adultMaxNum);
          }

          if (numberLabelClassList == "childrenLabel") {
            childCount += 1;
            adultChildIncrementHandler(childCount, childMaxNum);
          }
        };

        // Function to decrement count
        const handleDecrement = (numberLabelClassList) => {
          const {
            min: { adults: adultMinNum, child: childMinNum },
          } = adultChildMinMax;

          // Function to decrement adult or child
          const adultChildDecrementHandler = (typeCount, typeMin, type) => {
            if (type === "adult") {
              grammarNumHandler(typeCount, "adult");
            }
            if (type === "children") {
              grammarNumHandler(typeCount, "children");
            }

            if (typeCount == typeMin) {
              context.config._addClass([
                {
                  selector: targetButton,
                  className: "disabled",
                },
              ]);
            }
          };

          if (numberLabelClassList == "adultsLabel") {
            adultCount -= 1;
            adultChildDecrementHandler(adultCount, adultMinNum, "adult");
          }

          if (numberLabelClassList == "childrenLabel") {
            childCount -= 1;
            adultChildDecrementHandler(childCount, childMinNum, "children");
          }
        };

        if (buttonClass.contains("buttonPlus")) {
          handleIncrement(plusMinusLabelHolderClasses);
        }
        if (buttonClass.contains("buttonMinus")) {
          handleDecrement(plusMinusLabelHolderClasses);
        }

        // UPDATE ROOM SUMMARY WINDOW
        updateRoomSummary(adultCount, childCount);

        const {
          max: { adults: adultMaxNum, child: childMaxNum },
          min: { adults: adultMinNum, child: childMinNum },
        } = adultChildMinMax;

        if (adultCount > adultMinNum && adultCount < adultMaxNum) {
          adultPlusButton.classList.remove("disabled");
          adultMinusButton.classList.remove("disabled");
        }

        if (childCount > childMinNum && childCount < childMaxNum) {
          childPlusButton.classList.remove("disabled");
          childMinusButton.classList.remove("disabled");
        }

        childAgesRequiredLabel.style.display = childCount > childMinNum ? "block" : "none";

        // UPDATE HIDDEN INPUT VALUES
        const vacationRentalHiddenElement = document.querySelector('#vacation-rentals-form [data-hotel-input-type="adults"]');
        vacationRentalsAdultsCount.value = adultCount;
        vacationRentalsChildrenCount.value = childCount;
        vacationRentalHiddenElement.value = adultCount;

        if (!type) {
          const childAgeSelectHTML = `
								<div class="childAgeSelect">
									<div class="childAgeLabel col-sm-6">Age of Child ${childCount}</div>
									<div class=" col-sm-6">
										<hr class="invalid"><select aria-label="Age of Child ${childCount}" name="room[0].children[${childCount - 1}]" aria-required="true">
											<option value="" style="display:none;">Select</option>
											<option value="0">&lt; 1</option>
											<option value="1">Age 1</option>
											<option value="2" selected>Age 2</option>
											<option value="3">Age 3</option>
											<option value="4">Age 4</option>
											<option value="5">Age 5</option>
											<option value="6">Age 6</option>
											<option value="7">Age 7</option>
											<option value="8">Age 8</option>
											<option value="9">Age 9</option>
											<option value="10">Age 10</option>
											<option value="11">Age 11</option>
											<option value="12">Age 12</option>
											<option value="13">Age 13</option>
											<option value="14">Age 14</option>
											<option value="15">Age 15</option>
											<option value="16">Age 16</option>
											<option value="17">Age 17</option>
										</select>
										<div class="invalid">required</div>
									</div>
								</div>
							`;

          if (targetButton.classList.contains("buttonPlus")) {
            vacayRentalChildAgesContainer.insertAdjacentHTML("beforeend", childAgeSelectHTML);
          }

          if (targetButton.classList.contains("buttonMinus")) {
            const lastSelectElement = vacayRentalChildAgesContainer.lastElementChild;

            if (lastSelectElement) {
              vacayRentalChildAgesContainer.removeChild(lastSelectElement);
            }
          }
        }
      });
    };

    handleVacayRentalPlusMinus(vacationMinusButtonPlusChildren, null);
    handleVacayRentalPlusMinus(vacationMinusButtonMinusChildren, null);
    handleVacayRentalPlusMinus(vacationPlusParentButton, "parent");
    handleVacayRentalPlusMinus(vacationMinusParentButton, "parent");

    // Select children default value for Hotels
    const setDefaultAge = () => {
      const hotelChildrenDropdown = document.querySelectorAll("#hotel-form .childAgeSelect select");
      hotelChildrenDropdown.forEach((childDD) => {
        const childDDVal = childDD.value;
        childDD.value = childDDVal || "2";
      });
    };

    // Add / remove disabled attribute
    // Function to handle the addition or removal of the disabled attribute
    function handleDisabledAttribute(element) {
      if (element.classList.contains("disabled")) {
        element.setAttribute("disabled", true);
      } else {
        element.removeAttribute("disabled");
      }
    }

    // Set up the MutationObserver
    const observerHandleDisabledAttribute = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === "class") {
          const target = mutation.target;
          if (target.classList.contains("buttonMinus") || target.classList.contains("buttonPlus")) {
            handleDisabledAttribute(target);
            setDefaultAge();
          }
        }
      });
    });

    // Observe changes in the class attribute of all elements in the DOM
    const config = { attributes: true, subtree: true };
    observerHandleDisabledAttribute.observe(document.body, config);

    // Initial run to handle existing elements with the .buttonMinus or .buttonPlus class
    document.querySelectorAll(".buttonMinus, .buttonPlus").forEach((el) => handleDisabledAttribute(el));
  },

  hotelVacayRentalsDropdown: function (ddTarget, targetLabel, labelCollection, roomsContainer, fieldsContainer) {
    const context = this;
    const isHotelPresent = document.getElementById("hotel");
    const vacationPlusButtons = document.querySelectorAll("#vacation-rentals-form .buttonPlus");
    const vacationMinusButtons = document.querySelectorAll("#vacation-rentals-form .buttonMinus");
    const hotelMultipleRoomsBlurb = document.querySelector(".hotelMultipleRoomsBlurb ");

    targetLabel.innerHTML = labelCollection[3];
    fieldsContainer.append(roomsContainer);

    context.config._addClass([
      {
        selector: hotelMultipleRoomsBlurb,
        className: "col-sm-12",
      },
      {
        selector: roomsContainer,
        className: ["col-sm-12", "col-md-6"],
      },
    ]);

    if (ddTarget == "hotel") {
      let childAgesLabel = document.querySelector("#hotel-form .childAgesRequiredLabel"),
        childAgesContainer = isHotelPresent.querySelector("#hotel-form .childAgesContainer"),
        roomSummaryContainer = document.querySelector("#hotel-form .roomsSummary");

      childAgesLabel.append(childAgesContainer);

      context.config._addClass([
        {
          selector: roomSummaryContainer,
          className: "col-sm-12",
        },
      ]);

      context.config._setAttribute([
        {
          selector: roomSummaryContainer,
          attrType: "role",
          attrValue: "menu",
        },
        {
          selector: roomSummaryContainer,
          attrType: "aria-label",
          attrValue: "select room occupancy",
        },
      ]);
    }

    if (ddTarget == "vacationRentals") {
      let childAgesLabel = document.querySelector("#vacation-rentals-form .childAgesRequiredLabel"),
        childAgesContainer = isHotelPresent.querySelector("#vacation-rentals-form .childAgesContainer"),
        roomSummaryContainer = document.querySelector("#vacation-rentals-form .roomsSummary");

      childAgesLabel.append(childAgesContainer);

      context.config._addClass([
        {
          selector: roomSummaryContainer,
          className: "col-sm-12",
        },
      ]);

      context.config._setAttribute([
        {
          selector: roomSummaryContainer,
          attrType: "role",
          attrValue: "menu",
        },
        {
          selector: roomSummaryContainer,
          attrType: "aria-label",
          attrValue: "Click the menu to select room occupancy",
        },
        {
          selector: roomSummaryContainer,
          attrType: "tabindex",
          attrValue: "0",
        },
      ]);
    }

    const applyButtonAttributes = (targetButtons) => {
      targetButtons.forEach((button) => {
        if (button.previousElementSibling) {
          const isAdultButton = button.previousElementSibling.innerText.includes("Adults");
          const label = isAdultButton ? "Adult" : "Children";
          context.config._setAttribute([
            {
              selector: button,
              attrType: "aria-label",
              attrValue: `Add ${label}`,
            },
          ]);
        } else {
          const isAdultButton = button.nextElementSibling.innerText.includes("Adults");
          const label = isAdultButton ? "Adult" : "Children";
          context.config._setAttribute([
            {
              selector: button,
              attrType: "aria-label",
              attrValue: `Remove ${label}`,
            },
          ]);
        }
      });
    };

    applyButtonAttributes(vacationPlusButtons); // Vacation rental Plus button
    applyButtonAttributes(vacationMinusButtons); // Vacation rental  Minus button
  },

  widgetHotel: function () {
    const isHotelPresent = document.getElementById("hotel");
    if (isHotelPresent) {
      const context = this,
        hotelLabels = context.config.hotelLabels,
        hotelFieldsContainer = document.querySelector("#hotel-form .tst-widget-fields__container"),
        hotelRoomsContainer = document.querySelector("#hotel-form .rooms-grp"),
        hotelDestinationId = "hotels_destination",
        roomSelectionRows = document.querySelectorAll("#hotel-form .roomSelectionRow"),
        insertNewLabels = [...context.config.occupancyLabels];

      let hotelDestinationContainer = document.querySelector("#hotel-form .location"),
        hotelCheckInOutGroupContainer = document.querySelector("#hotel-form .grouped"),
        hotelOccupancyLabel = hotelCheckInOutGroupContainer.querySelector(".rooms-grp label");

      if (hotelDestinationContainer) {
        let hotelDestinationLabel = hotelDestinationContainer.children[0],
          hotelDestinationInput = hotelDestinationContainer.children[1].children[0];

        hotelFieldsContainer.append(hotelDestinationContainer);
        hotelDestinationLabel.innerHTML = hotelLabels[0];
        context.config._setAttribute([
          {
            selector: hotelDestinationInput,
            attrType: "id",
            attrValue: hotelDestinationId,
          },
          {
            selector: hotelDestinationInput,
            attrType: "placeholder",
            attrValue: "Where do you want to go?",
          },
          {
            selector: hotelDestinationLabel,
            attrType: "for",
            attrValue: hotelDestinationId,
          },
        ]);

        context.config._addClass([
          {
            selector: hotelDestinationContainer,
            className: ["col-md-6", "col-sm-12"],
          },
          {
            selector: hotelDestinationInput,
            className: "col-sm-12",
          },
        ]);
      }

      // convert minus button from <div> to <button> for accessibility

      const divMinusButtonsList = document.querySelectorAll(".buttonMinus");
      const divPlusButtonsList = document.querySelectorAll(".buttonPlus");
      const convertDivToButton = (divButtonList) => {
        divButtonList.forEach((divButton) => {
          const buttonElement = document.createElement("button");
          buttonElement.innerHTML = divButton.innerHTML;
          Array.from(divButton.attributes).forEach((attr) => {
            buttonElement.setAttribute(attr.name, attr.value);
          });
          buttonElement.removeAttribute("tabindex");
          buttonElement.removeAttribute("role");
          context.config._setAttribute([
            {
              selector: buttonElement,
              attrType: "type",
              attrValue: "button",
            },
          ]);
          divButton.parentNode.replaceChild(buttonElement, divButton);
        });
      };
      convertDivToButton(divMinusButtonsList);
      convertDivToButton(divPlusButtonsList);

      if (hotelCheckInOutGroupContainer) {
        let counter = 1;

        hotelFieldsContainer.append(hotelCheckInOutGroupContainer);

        for (let element of hotelCheckInOutGroupContainer.children) {
          if (element.children.length > 0 && counter <= 2) {
            element.children[0].innerHTML = hotelLabels[counter];
            counter++;
          }
          element.classList.add("col-sm-6");
        }
        hotelCheckInOutGroupContainer.classList.add("col-md-6", "col-sm-12");

        context.config._setAttribute([
          {
            selector: hotelCheckInOutGroupContainer.children[0].children[1],
            attrType: "placeholder",
            attrValue: context.config.dateFormat,
          },
          {
            selector: hotelCheckInOutGroupContainer.children[0].children[0],
            attrType: "for",
            attrValue: hotelCheckInOutGroupContainer.children[0].children[1].getAttribute("id"),
          },
          {
            selector: hotelCheckInOutGroupContainer.children[1].children[1],
            attrType: "placeholder",
            attrValue: context.config.dateFormat,
          },
          {
            selector: hotelCheckInOutGroupContainer.children[1].children[0],
            attrType: "for",
            attrValue: hotelCheckInOutGroupContainer.children[1].children[1].getAttribute("id"),
          },
        ]);
      }

      insertNewLabels[0] = "Rooms";
      insertNewLabels[2] = "Children (1&ndash;17)";

      TSTWidget.hotelVacayRentalsDropdown("hotel", hotelOccupancyLabel, hotelLabels, hotelRoomsContainer, hotelFieldsContainer);

      roomSelectionRows.forEach((roomSelectionRow, index) => {
        const ogHTML = roomSelectionRow.innerHTML;
        const newHTML = `<div class="occupancyLabel col-sm-6">${insertNewLabels[index]}</div><div class="plusMinusHolder col-sm-6"><div class="allHolder">${ogHTML}</div></div>`;
        roomSelectionRow.innerHTML = newHTML;
      });

      document.querySelectorAll(".childAgesRequiredLabel").forEach((childAgesLabels) => {
        context.config._addClass([
          {
            selector: childAgesLabels,
            className: "col-sm-12",
          },
        ]);
      });

      const hotelAdultMinusButton = roomSelectionRows[1].querySelector(".buttonMinus");

      context.config._addClass([
        {
          selector: hotelAdultMinusButton,
          className: "disabled",
        },
      ]);

      //Hotel Page Level error
      document.querySelector("#hotel-form button[type='submit']").addEventListener("click", () => {
        let validationFlagArray = [],
          isValid = false;
        const hotelForm = document.querySelector("#hotel-form");

        jQuery("#hotel-form input").each(function () {
          context.pageLevelErrors();
          jQuery(this).parsley().validate() !== true ? (isValid = false) : (isValid = true);
          validationFlagArray.push(isValid);
        });

        context.config._checker(validationFlagArray) ? hotelForm.removeAttribute("onsubmit") : hotelForm.setAttribute("onsubmit", "event.preventDefault();");
      });
    }
  },

  widgetVacationRentals: function () {
    const isVacationRentalsPresent = document.getElementById("hotel");
    if (isVacationRentalsPresent) {
      const context = this;
      const vacayRentalLabels = context.config.vacayRentalLabels;
      const vacayRentalFieldsContainer = document.querySelector("#vacation-rentals-form .tst-widget-fields__container");
      const vacayRentalDestinationId = "vacayRental_destination";
      const vacationFieldsContainer = document.querySelector("#vacation-rentals-form .tst-widget-fields__container");
      const vacationRoomsContainer = document.querySelector("#vacation-rentals-form .rooms-grp");
      const advSearchHolder = document.querySelector("#vacation-rentals-form .search-btn");
      const roomSelectionRows = document.querySelectorAll("#vacation-rentals-form .roomSelectionRow");
      const insertNewLabels = [...context.config.occupancyLabels];
      const vacayRentalDestinationContainer = document.querySelector("#vacation-rentals-form .location");
      const vacayRentalCheckInOutGroupContainer = document.querySelector("#vacation-rentals-form .grouped");
      const vacayRentalOccupancyLabel = vacayRentalCheckInOutGroupContainer.querySelector(".rooms-grp label");
      const vacayRentalLocationHolder = document.querySelectorAll("#vacation-rentals-form .location-input")[0];

      if (vacayRentalDestinationContainer) {
        const vacayRentalDestinationLabel = vacayRentalDestinationContainer.children[0];
        const vacayRentalDestinationInput = vacayRentalDestinationContainer.children[1].children[0];

        vacayRentalFieldsContainer.append(vacayRentalDestinationContainer);
        vacayRentalDestinationLabel.innerHTML = vacayRentalLabels[0];
        context.config._setAttribute([
          {
            selector: vacayRentalDestinationInput,
            attrType: "id",
            attrValue: vacayRentalDestinationId,
          },
          {
            selector: vacayRentalDestinationInput,
            attrType: "placeholder",
            attrValue: "Where do you want to go?",
          },
          {
            selector: vacayRentalDestinationLabel,
            attrType: "for",
            attrValue: vacayRentalDestinationId,
          },
        ]);

        context.config._addClass([
          {
            selector: vacayRentalDestinationContainer,
            className: ["col-md-6", "col-sm-12"],
          },
          {
            selector: vacayRentalDestinationInput,
            className: "col-sm-12",
          },
        ]);
      }

      if (vacayRentalCheckInOutGroupContainer) {
        let counter = 1;

        vacayRentalFieldsContainer.append(vacayRentalCheckInOutGroupContainer);

        for (let element of vacayRentalCheckInOutGroupContainer.children) {
          if (element.children.length > 0 && counter <= 2) {
            element.children[0].innerHTML = vacayRentalLabels[counter];
            counter++;
          }

          context.config._addClass([
            {
              selector: element,
              className: "col-sm-6",
            },
          ]);
        }

        context.config._addClass([
          {
            selector: vacayRentalCheckInOutGroupContainer,
            className: ["col-sm-12", "col-md-6"],
          },
        ]);

        context.config._setAttribute([
          {
            selector: vacayRentalCheckInOutGroupContainer.children[0].children[1],
            attrType: "placeholder",
            attrValue: context.config.dateFormat,
          },
          {
            selector: vacayRentalCheckInOutGroupContainer.children[0].children[0],
            attrType: "for",
            attrValue: vacayRentalCheckInOutGroupContainer.children[0].children[1].getAttribute("id"),
          },
          {
            selector: vacayRentalCheckInOutGroupContainer.children[1].children[1],
            attrType: "placeholder",
            attrValue: context.config.dateFormat,
          },
          {
            selector: vacayRentalCheckInOutGroupContainer.children[1].children[0],
            attrType: "for",
            attrValue: vacayRentalCheckInOutGroupContainer.children[1].children[1].getAttribute("id"),
          },
        ]);
      }

      const advanceSearchElement = document.createElement("div");
      advanceSearchElement.innerHTML = context.config.advanceSearchBurb;
      advSearchHolder.append(advanceSearchElement);
      const advSearchCopy = document.querySelector("#vacation-rentals-form > div.search-btn > div");

      if (window.innerWidth < 1000) {
        advSearchCopy.classList.add("tst-advanced-search");
      } else {
        advSearchCopy.classList.add("advance-search");
      }

      insertNewLabels[0] = "Adults";
      insertNewLabels[1] = "Children (1&ndash;17)";

      context.hotelVacayRentalsDropdown("vacationRentals", vacayRentalOccupancyLabel, vacayRentalLabels, vacationRoomsContainer, vacationFieldsContainer);

      const roomSummaryContainerVacationRental = document.querySelector("#vacation-rentals-form .roomsSummary");
      const roomSelectionContainerVacationRental = document.querySelector("#vacation-rentals-form .roomSelectionContainer");

      const showOccupancyPopOver = (roomSelectionContainer) => {
        if (!roomSelectionContainer.classList.contains("show")) {
          context.config._addClass([
            {
              selector: roomSelectionContainer,
              className: "show",
            },
          ]);
        } else {
          roomSelectionContainer.classList.remove("show");
        }
      };
      roomSummaryContainerVacationRental.addEventListener("click", () => {
        showOccupancyPopOver(roomSelectionContainerVacationRental);
      });

      roomSummaryContainerVacationRental.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          showOccupancyPopOver(roomSelectionContainerVacationRental);
        }
        if (event.key === "Escape") {
          roomSelectionContainer.classList.remove("show");
        }
        if (event.key === "Tab") {
          context.config._addClass([
            {
              selector: roomSelectionContainerVacationRental,
              className: "show",
            },
          ]);
        }
      });

      roomSelectionContainerVacationRental.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          roomSelectionContainerVacationRental.classList.remove("show");
        }
      });

      [...roomSelectionRows].forEach((roomSelectionRow, index) => {
        const ogHTML = roomSelectionRow.innerHTML;
        const newHTML = `<div class="occupancyLabel col-sm-6">${insertNewLabels[index]}</div><div class="plusMinusHolder col-sm-6"><div class="allHolder">${ogHTML}</div></div>`;
        roomSelectionRow.innerHTML = newHTML;
      });

      // Add right url for Vacation rentals
      const vacationRentalAdvanceSearchLink = document.querySelector("#vacation-rentals-form .advanced-search-link");
      const hostUrl = document.getElementById("tst_host_url_input");
      const vacationRentalsAdvanceSearchUrl = `https://${hostUrl.value}/vacationrental`;
      vacationRentalAdvanceSearchLink.setAttribute("href", vacationRentalsAdvanceSearchUrl);

      //Vacation Rental Page Level error
      document.querySelector("#vacation-rentals-form button[type='submit']").addEventListener("click", () => {
        let validationFlagArray = [],
          isValid = false;
        const vacayRentalForm = document.querySelector("#vacation-rentals-form");

        jQuery("#vacation-rentals-form input").each(function () {
          context.pageLevelErrors();
          jQuery(this).parsley().validate() !== true ? (isValid = false) : (isValid = true);
          validationFlagArray.push(isValid);
        });

        context.config._checker(validationFlagArray) ? vacayRentalForm.removeAttribute("onsubmit") : vacayRentalForm.setAttribute("onsubmit", "event.preventDefault();");
      });
    }

    // For carrying over adult selection over to TST for hotels tab
    const adultsVacationRentalHtml = `<input type="hidden" data-hotel-input-type="adults" data-hotel-room-ref="0" name="room[0].adults" value="2">`;
    const vacationRentalForm = document.querySelector("#vacation-rentals-form");
    vacationRentalForm.insertAdjacentHTML("beforeend", adultsVacationRentalHtml);
  },

  widgetCar: function () {
    const isCarPresent = document.getElementById("car");
    if (isCarPresent) {
      const context = this,
        carLabels = context.config.carLabels,
        carFieldsContainer = document.querySelector("#car-form .tst-widget-fields__container"),
        carLabelElements = document.querySelectorAll("#car-form label"),
        carInputElements = document.querySelectorAll("#car-form input"),
        carDropdownElements = document.querySelectorAll("#car-form select"),
        carAllFields = document.querySelectorAll("#car-form>div"),
        ids = ["car_pickup", "car_dropoff", "pickup_date", "pickup_time", "dropoff_date", "dropoff_time"],
        placeholderCopy = ["Airport, City, Area, Address, etc.", "Same as pick-up", context.config.dateFormat, context.config.dateFormat];

      for (const [i, carLabelElement] of carLabelElements.entries()) {
        carLabelElement.innerHTML = carLabels[i];
        context.config._setAttribute([
          {
            selector: carLabelElement,
            attrType: "for",
            attrValue: ids[i],
          },
        ]);
      }

      for (const [i, carInputElement] of carInputElements.entries()) {
        carInputElement.classList.add("col-sm-12");
        if (i > 1) {
          carInputElement.parentElement.classList.add("col-md-6", "col-sm-12");
        }
        if (i <= 1) {
          context.config._setAttribute([
            {
              selector: carInputElement,
              attrType: "id",
              attrValue: ids[i],
            },
          ]);
        }
        if (carInputElement.hasAttribute("placeholder")) {
          context.config._setAttribute([
            {
              selector: carInputElement,
              attrType: "placeholder",
              attrValue: placeholderCopy[i],
            },
          ]);
        }
      }

      for (let carDropdownElement of carDropdownElements) {
        carDropdownElement.classList.add("col-md-12");
        carDropdownElement.parentElement.classList.add("col-md-6", "col-sm-12");
      }

      context.config._setAttribute([
        {
          selector: carDropdownElements[0],
          attrType: "id",
          attrValue: ids[3],
        },
        {
          selector: carDropdownElements[1],
          attrType: "id",
          attrValue: ids[5],
        },
        {
          selector: carDropdownElements[0],
          attrType: "aria-required",
          attrValue: "true",
        },
        {
          selector: carDropdownElements[1],
          attrType: "aria-required",
          attrValue: "true",
        },
      ]);

      for (let carAllField of carAllFields) {
        if (carAllField.hasChildNodes() && carAllField.className != "search-btn") {
          carFieldsContainer.append(carAllField);
          carAllField.classList.add("col-md-6", "col-sm-12");
        }
      }

      //Car Page level error message
      document.querySelector("#car-form button").addEventListener("click", () => {
        let validationFlagArray = [],
          isValid = false;
        const carForm = document.querySelector("#car-form");

        jQuery("#car-form input").each(function () {
          jQuery(this).parsley().validate() !== true ? (isValid = false) : (isValid = true);
          validationFlagArray.push(isValid);
        });

        if (context.config._checker(validationFlagArray)) {
          carForm.removeAttribute("onsubmit");
        } else {
          carForm.setAttribute("onsubmit", "event.preventDefault();");
          context.pageLevelErrors();
        }
      });
    }
  },

  widgetFlight: function () {
    const isFlightPresent = document.getElementById("flight");
    if (isFlightPresent) {
      const context = this,
        flightLabels = context.config.flightLabels,
        flightFieldsContainer = document.querySelector("#flight-form .tst-widget-fields__container"),
        flightLabelElements = document.querySelectorAll("#flight-form label"),
        flightInputElements = document.querySelectorAll("#flight-form input"),
        flightAllFields = [
          document.querySelector("#flight-form .departure"),
          document.querySelector("#flight-form .arrival"),
          document.querySelector("#flight-form .departure-date"),
          document.querySelector("#flight-form .flight-return-date"),
          document.querySelector("#flight-form .num-people-grp"),
        ],
        ids = ["flight_departing", "flight_departing_date", "flight_destination", "flight_return_date", "flight_adults", "flight_seniors", "flight_children"],
        placeholder = ["Where are you leaving from?", "Where do you want to go?", context.config.dateFormat, context.config.dateFormat];

      for (const [i, flightLabelElement] of flightLabelElements.entries()) {
        flightLabelElement.innerHTML = flightLabels[i];
        context.config._setAttribute([
          {
            selector: flightLabelElement,
            attrType: "for",
            attrValue: ids[i],
          },
        ]);
      }

      for (const [i, flightInputElement] of flightInputElements.entries()) {
        if (flightInputElement.getAttribute("type") != "hidden") {
          flightInputElement.classList.add("col-sm-12");
        }
      }

      for (const [i, flightField] of flightAllFields.entries()) {
        flightFieldsContainer.append(flightField);
        if (flightField.classList[0] == "departure-date" || flightField.classList[0] == "flight-return-date") {
          flightField.classList.add("col-md-4", "col-sm-12");
        } else if (flightField.classList[0] == "grouped") {
          flightField.classList.add("col-md-4", "col-sm-12");
          flightField.children[0].children[1].children[0].remove();
          for (let element of flightField.children) {
            element.classList.add("col-md-8", "col-sm-12");
          }
          flightField.children[3].classList.add("d-none");
        } else {
          flightField.classList.add("col-md-6", "col-sm-12");
        }

        if (flightField.classList[0] != "grouped" && flightField.classList[0] != "arrival" && flightField.classList[0] != "departure-date" && flightField.classList[0] != "flight-return-date") {
          context.config._setAttribute([
            {
              selector: flightField.children[1],
              attrType: "id",
              attrValue: ids[i],
            },
          ]);
        }
        if (flightField.children[1].getAttribute("type") == "text") {
          context.config._setAttribute([
            {
              selector: flightField.children[1],
              attrType: "placeholder",
              attrValue: placeholder[i],
            },
          ]);
        }
      }

      context.config._setAttribute([
        {
          selector: flightAllFields[1].children[1],
          attrType: "id",
          attrValue: ids[2],
        },
        {
          selector: flightAllFields[4].children[0].children[1],
          attrType: "id",
          attrValue: ids[4],
        },
        {
          selector: flightAllFields[4].children[1].children[1],
          attrType: "id",
          attrValue: ids[5],
        },
        {
          selector: flightAllFields[4].children[2].children[1],
          attrType: "id",
          attrValue: ids[6],
        },
      ]);

      //Flight page level error messages
      document.querySelector("#flight-form button").addEventListener("click", () => {
        let validationFlagArray = [],
          isValid = false;
        const flightForm = document.querySelector("#flight-form");

        jQuery("#flight-form input").each(function () {
          jQuery(this).parsley().validate() !== true ? (isValid = false) : (isValid = true);
          validationFlagArray.push(isValid);
        });

        if (context.config._checker(validationFlagArray)) {
          flightForm.removeAttribute("onsubmit");
        } else {
          flightForm.setAttribute("onsubmit", "event.preventDefault();");
          context.pageLevelErrors();
        }
      });
    }
  },

  widgetVacation: function () {
    const isFlightPresent = document.getElementById("prepackaged");
    if (isFlightPresent) {
      const context = this,
        vacationLabels = context.config.vacationLabels,
        vacationFieldsContainer = document.querySelector("#prepackaged form .tst-widget-fields__container"),
        vacationLabelElements = document.querySelectorAll("#prepackaged form label"),
        travelers = document.querySelectorAll("#prepackaged form ul.travelers li"),
        numPeopleGrpDiv = document.createElement("DIV"),
        vacationAllFields = [
          document.querySelector("#prepackaged form .departure"),
          document.querySelector("#prepackaged form .arrival"),
          document.querySelector("#prepackaged form .departure-date"),
          document.querySelector("#prepackaged form .duration"),
          document.querySelector("#prepackaged form .children-ages"),
        ],
        ids = ["vacation_departing", "vacation_destination", "vacation_date", "vacation_duration", "vacation_rooms", "vacation_adults", "vacation_children"];

      for (const [i, vacationLabelElement] of vacationLabelElements.entries()) {
        vacationLabelElement.innerHTML = vacationLabels[i];
        context.config._setAttribute([
          {
            selector: vacationLabelElement,
            attrType: "for",
            attrValue: ids[i],
          },
        ]);
      }

      for (let field of vacationAllFields) {
        vacationFieldsContainer.append(field);
        field.classList.add("col-md-6", "col-sm-12");
        field.children[1].getAttribute("type") == "text"
          ? field.children[1].classList.add("col-sm-12")
          : context.config._setAttribute([
              {
                selector: field.children[1],
                attrType: "aria-required",
                attrValue: "true",
              },
            ]);
      }

      numPeopleGrpDiv.classList.add("num-people-grp", "grouped", "col-md-6", "col-sm-12", "vacations__group-container");
      vacationFieldsContainer.append(numPeopleGrpDiv);
      vacationFieldsContainer.append(vacationAllFields[4]);

      const numPeopleGrp = document.querySelector(".vacations__group-container");
      for (let traveler of travelers) {
        numPeopleGrp.innerHTML += `<div class='col-md-4 col-sm-4'> ${traveler.innerHTML} </div>`;
      }
      document.querySelector("#prepackaged form .travelers").remove();

      context.config._setAttribute([
        {
          selector: vacationAllFields[0].children[1],
          attrType: "id",
          attrValue: ids[0],
        },
        {
          selector: vacationAllFields[1].children[1],
          attrType: "id",
          attrValue: ids[1],
        },
        {
          selector: vacationAllFields[2].children[1],
          attrType: "id",
          attrValue: ids[2],
        },
        {
          selector: vacationAllFields[3].children[1],
          attrType: "id",
          attrValue: ids[3],
        },
        {
          selector: numPeopleGrp.children[0].children[1],
          attrType: "id",
          attrValue: ids[4],
        },
        {
          selector: numPeopleGrp.children[1].children[1],
          attrType: "id",
          attrValue: ids[5],
        },
        {
          selector: numPeopleGrp.children[2].children[1],
          attrType: "id",
          attrValue: ids[6],
        },
        {
          selector: vacationAllFields[2].children[1],
          attrType: "placeholder",
          attrValue: context.config.dateFormat,
        },
        {
          selector: numPeopleGrp.children[0].children[1],
          attrType: "aria-required",
          attrValue: "true",
        },
        {
          selector: numPeopleGrp.children[1].children[1],
          attrType: "aria-required",
          attrValue: "true",
        },
      ]);

      // Add right url for Vacation PAckages
      const vacationPackagesAdvanceSearch = document.querySelector("#prepackaged .advanced-search-link");
      const hostUrl = document.getElementById("tst_host_url_input");
      const vacationPackagesAdvanceSearchUrl = `https://${hostUrl.value}/prepackaged`;
      vacationPackagesAdvanceSearch.setAttribute("href", vacationPackagesAdvanceSearchUrl);

      //Vacation Page level error messages
      document.querySelector("#prepackaged form button").addEventListener("click", () => {
        let validationFlagArray = [],
          isValid = false;
        let totalTravelers = 0;
        const maxTravelers = 6;
        const vacationForm = document.querySelector("#prepackaged form");
        const vacationTravelerCountSelects = document.querySelectorAll(".vacations__group-container .travelers-count");
        const primaryTravelerCountSelect = document.querySelector("#vacation_adults");

        for (const selCount of vacationTravelerCountSelects) {
          totalTravelers += parseInt(selCount.value);
        }

        jQuery("#prepackaged form input").each(function () {
          context.pageLevelErrors();
          jQuery(this).parsley().validate() !== true ? (isValid = false) : (isValid = true);
          validationFlagArray.push(isValid);
        });

        if (totalTravelers > maxTravelers) {
          validationFlagArray.push(false);
          setMaxTravellersErrMsg();
        } else {
          unsetMaxTravellersErrMsg();
        }
        function setMaxTravellersErrMsg() {
          if (!primaryTravelerCountSelect.nextElementSibling || !primaryTravelerCountSelect.nextElementSibling.classList.contains("parsley-errors-list")) {
            primaryTravelerCountSelect.insertAdjacentHTML(
              "afterend",
              `<ul class="parsley-errors-list filled" id="parsley-id-69" aria-hidden="false"><li class="parsley-required">${context.config.maxTravelersExceeded}</li></ul>`
            );
            context.config._setAttribute([
              {
                selector: primaryTravelerCountSelect,
                attrType: "aria-describedby",
                attrValue: "parsley-id-69",
              },
            ]);
          }
        }
        function unsetMaxTravellersErrMsg() {
          if (primaryTravelerCountSelect.nextElementSibling && primaryTravelerCountSelect.nextElementSibling.classList.contains("parsley-errors-list")) {
            primaryTravelerCountSelect.nextElementSibling.remove();
            context.config._setAttribute([
              {
                selector: primaryTravelerCountSelect,
                attrType: "aria-describedby",
                attrValue: "",
              },
            ]);
          }
        }

        context.pageLevelErrors();
        context.config._checker(validationFlagArray) ? vacationForm.removeAttribute("onsubmit") : vacationForm.setAttribute("onsubmit", "event.preventDefault();");
      });

      //Store inputted child ages
      let ageObj = {};

      //Children addition
      document.querySelector("#vacation_children").addEventListener("change", () => {
        const customDiv = document.querySelectorAll(".custom_div");

        if (customDiv.length > 0) {
          for (let element of customDiv) {
            element.remove();
          }
        }

        setTimeout(() => {
          let ChildDropDowns = vacationAllFields[4].childNodes;
          let arr = [];
          ChildDropDowns.forEach((element) => {
            if (element.className === "child-age-dropdown") {
              const newDiv = document.createElement("DIV");
              newDiv.classList.add("col-md-4", "col-sm-4", "custom_div");
              vacationAllFields[4].append(newDiv);
              const elementName = element.getAttribute("name");
              if (elementName in ageObj) {
                element.value = ageObj[elementName];
              }
              setTimeout(() => {
                newDiv.append(element);
                arr.push(element.getAttribute("name"));
                element.addEventListener("change", () => {
                  ageObj[elementName] = element.value;
                });
                const elementName = element.getAttribute("name");
                if (elementName === "childAges[0]" && arr.length === 4) {
                  element.classList.add("mt-10");
                }
              }, 50);
            }
          });
        }, 100);

        setTimeout(() => {
          const renderedChildDropDowns = document.querySelectorAll(".child-age-dropdown");
          for (const [i, element] of renderedChildDropDowns.entries()) {
            context.config._setAttribute([
              {
                selector: element,
                attrType: "aria-label",
                attrValue: context.config.childAgeLabels[i],
              },
            ]);
          }
        }, 200);
      });
    }
  },

  widgetGuidedTours: function () {
    const isGuidedToursPresent = document.getElementsByClassName("tour-section");
    if (isGuidedToursPresent) {
      const context = this,
        guidedToursLabels = context.config.guidedToursLabels,
        tourSectionHolder = document.querySelector(".forms .tour-section"),
        tourForm = tourSectionHolder.querySelector("form"),
        advSearchHolder = document.createElement("div");

      tourSectionHolder.id = "tours";
      tourForm.id = "tours-form";
      advSearchHolder.innerHTML = context.config.advanceSearchBurb;

      context.config._addClass([
        {
          selector: advSearchHolder,
          className: "advance-search",
        },
      ]);

      let tourSearchHolder = document.querySelector("#tours-form > .search-btn"),
        guidedToursContainer = tourForm.querySelector(".tst-widget-fields__container"),
        guidedToursAllFields = [tourForm.querySelector(".location"), tourForm.querySelector(".month")],
        ids = ["tours_destinationSelectBoxIt", "tours_month"];

      tourSearchHolder.append(advSearchHolder);

      for (const [i, field] of guidedToursAllFields.entries()) {
        guidedToursContainer.append(field);
        field.children[0].innerText = guidedToursLabels[i];

        context.config._addClass([
          {
            selector: field,
            className: ["col-sm-12", "col-md-6"],
          },
          {
            selector: field.children[1],
            className: "col-sm-12",
          },
        ]);

        context.config._setAttribute([
          {
            selector: field.children[0],
            attrType: "for",
            attrValue: ids[i],
          },
          {
            selector: field.children[1],
            attrType: "id",
            attrValue: ids[i],
          },
        ]);
      }

      context.config._setAttribute([
        {
          selector: guidedToursAllFields[0].children[1],
          attrType: "placeholder",
          attrValue: "Enter location or activity",
        },
        {
          selector: guidedToursAllFields[1].children[1],
          attrType: "aria-required",
          attrValue: "true",
        },
        {
          selector: guidedToursAllFields[0].children[1],
          attrType: "aria-label",
          attrValue: "Destination",
        },
      ]);

      // Add right url for Tours
      const guidedToursAdvanceSearchLink = document.querySelector("#tours-form .advanced-search-link");
      const hostUrl = document.getElementById("tst_host_url_input");
      const guidedToursAdvanceSearchUrl = `https://${hostUrl.value}/tour`;
      guidedToursAdvanceSearchLink.setAttribute("href", guidedToursAdvanceSearchUrl);

      //Activity Page validation
      tourForm.querySelector(".search-btn button").addEventListener("click", () => {
        let validationFlagArray = [],
          isValid = false;

        jQuery("#tours-form form input").each(function () {
          context.pageLevelErrors();
          jQuery(this).parsley().validate() !== true ? (isValid = false) : (isValid = true);
          validationFlagArray.push(isValid);
        });

        context.config._checker(validationFlagArray) ? tourForm.removeAttribute("onsubmit") : tourForm.setAttribute("onsubmit", "event.preventDefault();");
      });
    }
  },

  widgetCruise: function () {
    const cruiseSection = document.getElementById("cruise");
    if (cruiseSection) {
      const context = this,
        cruiseLabels = context.config.cruiseLabels,
        cruiseFieldsContainer = document.querySelector("#cruise form .tst-widget-fields__container"),
        cruiseAllFields = [
          document.querySelector("#cruiseDestination"),
          document.querySelector("#cruiseDays"),
          document.querySelector("#cruiseMonth"),
          document.querySelector("#cruiseLine"),
          document.querySelector("#cruiseTravelers"),
        ],
        ids = ["cruise_destination", "cruise_duration", "cruise_month", "cruise_line", "cruise_travelers"];

      context.config._setAttribute([
        {
          selector: cruiseSection,
          attrType: "aria-labelledby",
          attrValue: "tst_cruises_tab",
        },
      ]);

      for (const [i, field] of cruiseAllFields.entries()) {
        let elementLabel = document.createElement("LABEL");
        elementLabel.innerText = cruiseLabels[i];

        cruiseFieldsContainer.append(field.parentNode);
        field.parentNode.prepend(elementLabel);

        context.config._setAttribute([
          {
            selector: elementLabel,
            attrType: "for",
            attrValue: field.getAttribute("id"),
          },
        ]);

        field.classList.add("col-sm-12");
        field.parentElement.classList.add("col-md-6", "col-sm-12");
        context.config._setAttribute([
          {
            selector: field,
            attrType: "aria-required",
            attrValue: "true",
          },
        ]);
      }
    }
  },

  widgetActivity: function () {
    const isActivityPresent = document.getElementById("activity");
    if (isActivityPresent) {
      const context = this,
        activityLabels = context.config.activityLabels,
        activityFieldsContainer = document.querySelector("#activity form .tst-widget-fields__container"),
        activityAllFields = [document.querySelector("#activity form .location"), document.querySelector("#activity form .monthYear")],
        ids = ["activity_destination", "activity_month"];

      for (const [i, field] of activityAllFields.entries()) {
        activityFieldsContainer.append(field);
        field.classList.add("col-sm-12", "col-md-6");
        field.children[1].classList.add("col-sm-12");
        field.children[0].innerText = activityLabels[i];

        context.config._setAttribute([
          {
            selector: field.children[0],
            attrType: "for",
            attrValue: ids[i],
          },
          {
            selector: field.children[1],
            attrType: "id",
            attrValue: ids[i],
          },
        ]);
      }

      context.config._setAttribute([
        {
          selector: activityAllFields[0].children[1],
          attrType: "placeholder",
          attrValue: "Enter location or activity",
        },
        {
          selector: activityAllFields[1].children[1],
          attrType: "aria-required",
          attrValue: "true",
        },
        {
          selector: activityAllFields[0].children[1],
          attrType: "aria-label",
          attrValue: "Destination",
        },
      ]);

      //Activity Page validation
      document.querySelector("#activity form button").addEventListener("click", () => {
        let validationFlagArray = [],
          isValid = false;
        const activityForm = document.querySelector("#activity form");

        jQuery("#activity form input").each(function () {
          context.pageLevelErrors();
          jQuery(this).parsley().validate() !== true ? (isValid = false) : (isValid = true);
          validationFlagArray.push(isValid);
        });

        context.config._checker(validationFlagArray) ? activityForm.removeAttribute("onsubmit") : activityForm.setAttribute("onsubmit", "event.preventDefault();");
      });
    }
  },

  eventHandlers: function () {
    const context = this,
      tabs = document.querySelector(".tst-search-widget .tabs"),
      scrollContainer = tabs.children[0],
      fadeBackground = document.createElement("DIV");

    //Faded nav block
    tabs.appendChild(fadeBackground);
    tabs.children[1].classList.add("fade-background", "fade-background--right");

    scrollContainer.addEventListener("scroll", () => {
      const rightScrollPos = (scrollContainer.scrollLeft + scrollContainer.clientWidth).toFixed(),
        leftScrollPos = scrollContainer.scrollLeft,
        scrollWidth = scrollContainer.scrollWidth,
        fadeBackground = document.querySelector(".fade-background");
      if (rightScrollPos == scrollWidth) {
        fadeBackground.classList.remove("fade-background--right");
        fadeBackground.classList.add("fade-background--left");
      }
      if (leftScrollPos == 0) {
        fadeBackground.classList.remove("fade-background--left");
        fadeBackground.classList.add("fade-background--right");
      }
    });
  },

  formValidation: function () {
    //Adding parsley-required message
    var widgetInputs = document.querySelectorAll("#caa-widget-travel input");
    for (let input in widgetInputs) {
      if (input < 40) {
        if (widgetInputs[input].getAttribute("type") != "hidden") {
          if (widgetInputs[input].getAttribute("name") != "dropOffLocation" && widgetInputs[input].getAttribute("name") != "checkIn" && widgetInputs[input].getAttribute("name") != "checkOut") {
            widgetInputs[input].setAttribute("data-parsley-required", "true");
            widgetInputs[input].setAttribute("aria-required", "true");
          }
          if (widgetInputs[input].getAttribute("type") == "text") {
            if (widgetInputs[input].previousElementSibling != null) {
              widgetInputs[input].setAttribute("data-parsley-required-message", widgetInputs[input].previousElementSibling.innerHTML + " is required.");
            }

            if (widgetInputs[input].parentElement.previousSibling != null) {
              if (widgetInputs[input].parentNode.previousElementSibling != null && widgetInputs[input].parentNode.previousElementSibling.nodeName == "LABEL") {
                widgetInputs[input].setAttribute("data-parsley-required-message", widgetInputs[input].parentNode.previousElementSibling.innerHTML + " is required.");
              }
            }
          }
        }
      }
    }

    //Remove all TST error messages
    jQuery(".tst-error-message").remove();
  },

  pageLevelErrors: function () {
    const context = this,
      errors = document.querySelectorAll("ul.filled"),
      errorBlock = document.querySelector(".page-error-block__details"),
      errorListDiv = document.getElementById("page_error_list"),
      errorCount = document.getElementById("page_error_count"),
      errorSummaryContainer = document.getElementById("page_error_block");

    errorListDiv.innerHTML = "";
    errorCount.innerText = errors.length;

    if (errors.length > 0) {
      errorBlock.classList.remove("d-none");
      context.config._setAttribute([
        {
          selector: errorSummaryContainer,
          attrType: "aria-live",
          attrValue: "assertive",
        },
        {
          selector: errorSummaryContainer,
          attrType: "role",
          attrValue: "text",
        },
      ]);
      window.location.hash = "#page_error_block";
      errorSummaryContainer.focus();
    } else {
      errorBlock.classList.add("d-none");
    }

    for (const [i, error] of errors.entries()) {
      const inputId = document.querySelector(`[aria-describedby='${error.id}']`).id,
        errInputElement = document.getElementById(`${inputId}`);
      errorListDiv.innerHTML +=
        "<li><span>Error " +
        (i + 1) +
        ": </span><span><a href='#" +
        inputId +
        "'>" +
        error.innerText +
        "</a></span>" +
        (errInputElement.hasAttribute("data-format") ? "<span> (Format: " + errInputElement.getAttribute("data-format") + ")</span>" : "") +
        "</li>";
    }
  },

  selectActiveTab: function () {
    const context = this;
    const allTabs = document.querySelectorAll("#caa-widget-travel #tst-tabs ul li");

    for (let tab of allTabs) {
      tab.children[0].setAttribute("aria-pressed", "false");

      if (tab.classList.contains("active")) {
        tab.children[0].setAttribute("aria-pressed", "true");

        if (context.config.currTab === "tst_hotel_tab") {
          const toggleHotelsButton = document.querySelector("#hotels");
          const toggleVacationRentalButton = document.querySelector("#vacationRentals");
          context.config._toggleTabFeatureButtons(toggleHotelsButton, toggleVacationRentalButton);
        }
		else if (context.config.currTab === "tst_vacation_tab") {
          const toggleVacationPackagesButton = document.querySelector("#vacationPackages");
          const toggleGuidedToursButton = document.querySelector("#guidedTours");
          // Shift toggle button DOM Parent
          const toggleBtnParent = toggleVacationPackagesButton.closest("div.formToggle");
          const newDOMParent = document.querySelector("#prepackaged");
		  // Set the Active tab Vacation packages
          newDOMParent.prepend(toggleBtnParent);
          context.config._toggleTabFeatureButtons(toggleVacationPackagesButton, toggleGuidedToursButton);
        }
        context.config.currTab = tab.children[0].getAttribute("id");
      }

      tab.classList.contains("active");
    }
  },
};


jQuery("#caa-widget-travel").on("tst-widget-created", function (e) {
	TSTWidget.init();
});

//********** TST Autocomplete styling
jQuery("#caa-widget-travel").on("tst-autocomplete-init", function () {
	const existingInlineStyle = document.getElementById("inline_style");
	if (existingInlineStyle) {
		existingInlineStyle.remove();
	}
	const inlineStyle = document.createElement('style');
	inlineStyle.id = 'inline_style';
	document.getElementsByTagName('head')[0].appendChild(inlineStyle);

	for (const [i, input] of document.querySelectorAll("#caa-widget-travel form input").entries()) {
		if (input.type != "hidden" && input.classList.contains("ui-autocomplete-input")) {
			input.addEventListener("keyup", function () {
				const autocompleteList = document.querySelectorAll(".ui-autocomplete"),
					inlineStyle = document.querySelector("#inline_style");
				let inputWidth = this.offsetWidth;

				inlineStyle.innerHTML = ".variable-width{ width: " + inputWidth + "px !important}";

				for (let autocompleteItem of autocompleteList) {
					autocompleteItem.style.position = "absolute";
					autocompleteItem.classList.add("variable-width");
				}
			})
		}
	}
})


//********** TST Tab change
jQuery("#caa-widget-travel").on('tst-tab-change', function () {
	// reset error messages
	const errorList = document.querySelector("#page_error_list"),
		allForms = jQuery("#caa-widget-travel form"),
		errorBlock = document.querySelector(".page-error-block");
	errorList.innerHTML = "";
	errorBlock.classList.add("d-none");

	allForms.each(function () {
		jQuery(this).parsley().reset();
	});

	setTimeout(() => {
		TSTWidget.selectActiveTab()
	}, 50);
});
